var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"software-grid"},_vm._l((_vm.softWareData),function(item,index){return _c('div',{key:index,staticClass:"software-grid-item"},[_c('oneSoftWare',{attrs:{"infoDetails":item}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }